export const GROUPS_DEFAULT_PER_PAGE = 20;
export const GROUP_MEMBERS_DEFAULT_PER_PAGE = 20;
export const JOINED_GROUPS_DEFAULT_PER_PAGE = 100;
